export default __webpack_public_path__ + "static/media/interior-one-mobile.83ad1c83.jpg";